/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".category-link-modal .info-body{width:100%;max-height:450px;min-height:55px;overflow-y:auto;text-align:left;padding:16px 0}.category-link-modal .info-body .cancel-btn{margin-top:24px}.category-link-modal .info-body .mb-10{margin-bottom:10px}.category-link-modal .info-body .my-10{margin:10px 0}.category-link-modal .info-body .code-area{padding:10px;background-color:#eee}.category-link-modal .info-body code{background:#eee;font-size:.9em}.category-link-modal .info-body pre{display:block;margin:0;white-space:pre;white-space:pre-line;background:#eee}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/show.category.link.modal/show.category.link.modal.component.scss.ngstyle.js.pre-build-optimizer.js